import React from 'react';
import { inject, observer } from 'mobx-react';
import { getSearchParams } from '../../util/loginUtil';
import E9Login from './e9login/E9Login';

@inject('portalLoginStore')
@observer
class Login extends React.Component {
  constructor(props) {
    super(props);
  }

  componentWillMount() {
    // console && console.log('Login -> componentWillMount -> this.props:');
    // console && console.log(this.props);

    const { portalLoginStore, location = {} } = this.props;
    const { state } = portalLoginStore;
    const { templateType } = state;
    // 加载自定义登录组件
    if (templateType == 'ECustom') {
      const { layoutData = {} } = state;
      portalLoginStore.onLoadECustomLogin(layoutData);
    }
    const { query = {} } = location;
    const params = { ...getSearchParams(window.location.search), ...query };
    portalLoginStore.setQueryParams(params);
    portalLoginStore.getUpgradeInfo(params);
  }

  componentWillReceiveProps(nextProps) {
    // console && console.log('Login -> componentWillReceiveProps -> nextProps:');
    // console && console.log(nextProps);
    
    const { portalLoginStore, location = {} } = nextProps;
    const { query = {} } = location;
    const params = { ...getSearchParams(window.location.search), ...query };
    portalLoginStore.setQueryParams(params);
  }

  render() {
    const { portalLoginStore } = this.props;
    const { updatestatus, casstatus, beforLoginRenderEventStatus, state, customLoading } = portalLoginStore;
    const { id, templateType, layoutData = {} } = state;

    if (updatestatus != '0' || casstatus != '0' || !beforLoginRenderEventStatus || !id) {
      return <div />;
    }

    switch (templateType) {
      case 'ECustom':
        const { layoutId, layoutType, layoutCustom, layoutConfig = {}, layoutUUID } = layoutData;
        if (layoutCustom == '1') {
          // 使用自定义登录组件
          if (customLoading && window[layoutConfig.module]) {
            const ECustomLogin = window[layoutConfig.module]['com'][layoutConfig.component];
            return <ECustomLogin {...this.props} />;
          } else {
            if (window.rewritePortalLogin && typeof window.rewritePortalLogin == 'function') {
              return window.rewritePortalLogin({ ...this.props }, { id: layoutUUID });
            } else {
              return <div />;
            }
          }
        } else {
          // 使用特色门户布局
          if (customLoading && window['weaPortalPublic']) {
            return <window.weaPortalPublic.WeaPortalLayout id={layoutId} layoutId={layoutId} layoutType={layoutType} {...this.props} />;
          } else {
            return <div />;
          }
        }
      case 'E9':
        return <E9Login />;
      default:
        return <E9Login />;
    }
  }
}

export default Login;



// WEBPACK FOOTER //
// ../src4js/pc4mobx/portal4theme/components/login/index.js